import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const pl: AppStrings = {
  // COMMON
  error_title: 'Błąd',
  cancel: 'Anuluj',
  retry: 'Spróbuj ponownie',
  back_arrow: '← Wróć',

  // ASK SCREEN
  ask_box_unavailable: 'Skrzynka niedostępna',
  ask_box_unavailable_desc: 'Link może być nieaktualny lub właściciel zamknął skrzynkę.',
  ask_create_own_box: 'Utwórz własną skrzynkę',
  ask_sent_title: 'Wysłano ✅',
  ask_sent_desc: 'Twoje anonimowe pytanie dotarło do właściciela skrzynki.',
  ask_anonymous_hint: 'Twoje pytanie zostanie wysłane anonimowo.',
  ask_placeholder: 'Napisz pytanie…',
  ask_send: 'Wyślij',
  ask_sending: 'Wysyłanie…',
  ask_error_rate_limit: 'Za dużo zapytań — poczekaj chwilę.',
  ask_error_restart: 'Uruchom ponownie Mini App.',
  ask_error_load: 'Nie udało się załadować skrzynki.',
  ask_error_send: 'Nie udało się wysłać pytania.',
  ask_error_banned: 'Jesteś zablokowany w aplikacji.',
  ask_banned_appeal_btn: 'Odwołaj się',
  ask_appeal_sent: 'Odwołanie wysłane. Rozpatrzymy je ręcznie.',

  // AGE GATE
  age_gate_title: 'Tylko dla 18+',
  age_gate_desc:
    'Wysyłasz anonimowe pytanie. Zachowaj szacunek: zabronione są nękanie, groźby, treści seksualne dotyczące nieletnich oraz wszelkie treści naruszające prawo. Anonimowość nie oznacza bezkarności — naruszenia są zgłaszane do moderacji. Wysyłając pytanie, potwierdzasz, że masz 18 lat i akceptujesz regulamin.',
  age_gate_confirm: 'Mam 18 lat — kontynuuj',

  // INBOX SCREEN
  inbox_title: 'Skrzynka pytań',
  box_link_accordion: 'Link zaproszenia',
  inbox_notifications_ask: '🔔 Zezwolić botowi na wysyłanie powiadomień o nowych pytaniach?',
  inbox_notifications_allow: 'Zezwól',
  inbox_notifications_dismiss_label: 'Odrzuć',
  inbox_box_toggle_disable: 'Wyłącz pytania',
  inbox_box_toggle_enable: 'Włącz pytania',
  inbox_box_disabled_warning: 'Pytania są wyłączone — nowe pytania nie będą przyjmowane.',
  inbox_share_hint: 'Udostępnij link, a znajomi będą mogli zadać Ci anonimowe pytania.',
  inbox_copy: 'Kopiuj',
  inbox_copied: 'Skopiowano',
  inbox_copy_error: 'Błąd',
  inbox_no_deeplink: 'Link pojawi się po deploy.',
  inbox_invite_story: 'Zaproś przez Story',
  inbox_invite_chat: 'Zaproś przez czat',
  inbox_card_rendering: 'Karta zaproszenia jest jeszcze renderowana.',
  inbox_story_unsupported:
    'Stories nie są dostępne w tej wersji Telegram. Spróbuj „przez czat".',
  inbox_story_error: 'Nie udało się otworzyć Story.',
  inbox_chat_unsupported:
    'Udostępnianie przez czat nie jest dostępne w tej wersji Telegram. Zaktualizuj klienta.',
  inbox_chat_error: 'Nie udało się udostępnić. Spróbuj ponownie.',
  inbox_chat_prepare_error: 'Nie udało się przygotować zaproszenia.',
  inbox_filter_incoming: 'Przychodzące',
  inbox_filter_hidden: 'Ukryte',
  inbox_filter_blocked: 'Zablokowane',
  inbox_filter_empty: 'Tu jeszcze nic nie ma.',
  inbox_acc_unanswered: 'Bez odpowiedzi',
  inbox_acc_answered: 'Odpowiedziane',
  inbox_acc_hidden: 'Ukryte',
  inbox_acc_blocked: 'Zablokowane',
  inbox_empty: 'Brak pytań. Udostępnij link powyżej.',
  inbox_load_more: 'Załaduj więcej',
  inbox_load_more_error: 'Nie udało się załadować następnej strony.',
  inbox_error_load: 'Nie udało się załadować skrzynki.',
  inbox_rate_limit: 'Za dużo zapytań — poczekaj chwilę.',
  inbox_toggle_error: 'Nie udało się zmienić statusu skrzynki.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Napisz do mnie anonimowo',
  message_placeholder: 'Napisz wiadomość…',
  message_anonymous_hint: 'Twoja wiadomość zostanie wysłana anonimowo.',
  message_sent_title: 'Wysłano ✅',
  message_sent_desc: 'Twoja anonimowa wiadomość została dostarczona.',
  message_owner_entry: 'Napisz do mnie',
  message_share_hint: 'Udostępnij link, a każdy będzie mógł wysłać Ci anonimową wiadomość.',
  message_inbox_open: 'Otrzymane wiadomości',
  message_inbox_title: 'Wiadomości',
  message_inbox_empty: 'Brak wiadomości. Udostępnij swój link powyżej.',

  // ANSWER SCREEN
  answer_title: 'Odpowiedź na pytanie',
  answer_placeholder: 'Napisz odpowiedź…',
  answer_submit: 'Wyślij',
  answer_submitting: 'Wysyłanie…',
  answer_back: 'Wróć',
  answer_error_send: 'Nie udało się wysłać odpowiedzi.',

  // SHARE SCREEN
  share_title: 'Odpowiedź opublikowana ✅',
  share_hint: 'Udostępnij kartę i zbierz jeszcze więcej pytań.',
  share_card_rendering_desc:
    'Karta jest jeszcze renderowana. Wróć do pytań i sprawdź za chwilę — będziesz mógł udostępnić ją w Story lub czacie.',
  share_card_alt: 'Karta odpowiedzi',
  share_story_btn: 'Udostępnij w Story',
  share_story_btn_busy: 'Otwieranie…',
  share_chat_btn: 'Udostępnij w czacie',
  share_chat_btn_busy: 'Przygotowuję…',
  share_back: 'Wróć do pytań',
  share_story_unsupported:
    'Stories nie są dostępne w tej wersji Telegram. Spróbuj „Udostępnij w czacie".',
  share_story_error: 'Nie udało się otworzyć Story. Spróbuj „Udostępnij w czacie".',
  share_chat_sent: 'Wiadomość wysłana.',
  share_chat_unsupported:
    'Udostępnianie przez czat nie jest dostępne w tej wersji Telegram. Zaktualizuj klienta.',
  share_chat_error: 'Nie udało się udostępnić. Spróbuj ponownie.',
  share_chat_prepare_error: 'Nie udało się przygotować wiadomości.',

  // LEADERBOARD SCREEN
  lb_title: 'Ranking',
  lb_period_7d: '7 dni',
  lb_period_30d: '30 dni',
  lb_period_all: 'Cały czas',
  lb_group_label: 'Kategoria',
  lb_group_all: 'Wszystkie',
  lb_group_ask: 'Pytania',
  lb_group_rate: 'Oceny',
  lb_group_confession: 'Wyznania',
  lb_group_guesswho: 'Zgadnij kto',
  lb_group_message: 'Wiadomości',
  lb_error: 'Nie udało się załadować rankingu',
  lb_empty: 'Nikt jeszcze nie jest w rankingu',
  lb_anon: 'Anonim',
  lb_load_more: 'Załaduj więcej',
  lb_questions: (n) =>
    plural('pl', n, {
      one: '{n} pyt.',
      few: '{n} pyt.',
      many: '{n} pyt.',
      other: '{n} pyt.',
    }),
  lb_referrals: (n) => `${n} ref.`,

  // REWARDS SCREEN
  rw_title: 'Moje nagrody',
  rw_error: 'Nie udało się załadować nagród',
  rw_level: (n) => `Poziom ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('pl', n, {
      one: '{n} potwierdzony polecony',
      few: '{n} potwierdzone polecenia',
      many: '{n} potwierdzonych poleceń',
      other: '{n} potwierdzonych poleceń',
    }),
  rw_next_level_section: (n) =>
    plural('pl', n, {
      one: 'NASTĘPNY POZIOM — {n} polecenie',
      few: 'NASTĘPNY POZIOM — {n} polecenia',
      many: 'NASTĘPNY POZIOM — {n} poleceń',
      other: 'NASTĘPNY POZIOM — {n} poleceń',
    }),
  rw_to_level: (level, target) => `do poziomu ${level}: ${target}`,
  rw_max_level: 'Osiągnięto maksymalny poziom!',
  rw_badges_section: 'ODZNAKI',
  rw_formats_section: 'FORMATY SKRZYNKI',

  // QUESTION CARD
  qcard_status_new: 'Nowe',
  qcard_status_hidden: 'Ukryte',
  qcard_status_answered: 'Odpowiedziane',
  qcard_moderation_flagged: 'Uwaga: podejrzana wiadomość',
  qcard_answer_btn: 'Odpowiedz',
  qcard_answer_send: 'Wyślij',
  qcard_share_btn: 'Udostępnij',
  qcard_hide_btn: 'Ukryj',
  qcard_show_btn: 'Pokaż',
  qcard_report_btn: 'Zgłoś',
  qcard_block_btn: 'Zablokuj',
  qcard_unblock_btn: 'Odblokuj',
  qcard_report_reason_label: 'Wybierz powód zgłoszenia:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Nękanie',
  qcard_reason_sexual: 'Treści seksualne',
  qcard_reason_other: 'Inne',
  qcard_error_hide: 'Nie udało się zmienić widoczności.',
  qcard_error_report: 'Nie udało się wysłać zgłoszenia.',
  qcard_error_block: 'Nie udało się zablokować nadawcy.',
  qcard_report_done: 'Zgłoszenie wysłane — dziękujemy.',
  qcard_block_done: 'Nadawca zablokowany.',
  qcard_unblock_done: 'Nadawca odblokowany.',

  // ERRORS
  err_network: 'Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.',
  err_server_unavailable: 'Serwer jest chwilowo niedostępny, spróbuj później.',
  err_internal: 'Coś poszło nie tak. Już wiemy o problemie — spróbuj później.',
  err_bad_request: 'Sprawdź wprowadzone dane.',
  err_generic: 'Nie udało się wykonać akcji, spróbuj później.',
  err_schema: 'Błąd danych. Spróbuj zaktualizować aplikację.',
  share_story_link_premium_note:
    'Klikalny link w Stories wymaga Telegram Premium. Bez niego znajomi i tak Cię znajdą — Twoja nazwa użytkownika jest widoczna na karcie.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Błąd dostępu',
  auth_error_desc:
    'Nie udało się uwierzytelnić. Zamknij i ponownie otwórz Mini App z Telegrama.',

  // REWARD TOAST
  reward_toast_title: 'Nowa nagroda!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Pytania',
  tab_leaderboard: 'Ranking',
  tab_rewards: 'Nagrody',
  tab_settings: 'Ustawienia',

  // SETTINGS SCREEN
  settings_title: 'Ustawienia',
  settings_section_general: 'Ogólne',
  settings_notifications: 'Powiadomienia o nowych pytaniach',
  settings_notifications_hint: 'Bot wyśle Ci wiadomość, gdy ktoś zada pytanie.',
  settings_notifications_error: 'Nie udało się zapisać ustawień powiadomień.',
  settings_language: 'Język',
  settings_language_error: 'Nie udało się zmienić języka. Spróbuj ponownie.',
  settings_section_about: 'O aplikacji',
  settings_version: 'Wersja',

  // CODE ENTRY (work-020)
  code_modal_title: 'Link w Stories tylko dla Premium',
  code_modal_explain:
    'Telegram daje klikalny link w Stories tylko subskrybentom Premium. Możesz jednak dodać swój kod do Stories — widzowie wpiszą go w aplikacji i zadają Ci anonimowe pytanie.',
  code_modal_your_code: 'Twój kod',
  code_modal_copy: 'Kopiuj kod',
  code_modal_copied: 'Skopiowano',
  code_modal_share_btn: 'Udostępnij w Stories',
  code_modal_loading: 'Pobieranie kodu…',
  code_modal_error: 'Nie udało się pobrać kodu. Spróbuj później.',
  ask_code_title: 'Wpisz kod',
  ask_code_desc:
    'Przyszedłeś ze Stories? Znajdź w nim kod (np. 1234) i wpisz go poniżej.',
  ask_code_placeholder: 'Kod ze Stories',
  ask_code_find: 'Znajdź',
  ask_code_not_found: 'Nie znaleziono kodu. Sprawdź cyfry i spróbuj ponownie.',
  ask_code_invalid: 'Kod składa się z 4 cyfr.',
  code_onboarding_header: 'Przyszedłeś ze Stories?',
  code_onboarding_text: 'Wpisz kod znajomego, żeby zadać mu anonimowe pytanie.',
  code_onboarding_action: 'Wpisz kod',
  settings_ask_by_code: 'Pytaj przez kod',
  settings_my_code_title: 'Twój kod do Stories',
  settings_my_code_hint:
    'Wpisz ten kod w Stories — widzowie go wprowadzą, by zadać Ci anonimowe pytanie. Klikalny link w Stories Telegram daje tylko subskrybentom Premium.',
  settings_my_code_rotate: 'Pobierz nowy kod',
  settings_my_code_rotating: 'Aktualizowanie…',
  settings_my_code_done: 'Kod zaktualizowany',
  settings_my_code_error: 'Nie udało się pobrać kodu.',
  settings_my_code_rotate_confirm_title: 'Zmienić kod?',
  settings_my_code_rotate_confirm_desc:
    'Twój stary kod od razu przestanie działać. Nikt, kto widział go w Twojej relacji, nie będzie mógł się z Tobą skontaktować. Zmieniaj go tylko wtedy, gdy ktoś Cię spamuje.',
  settings_my_code_rotate_confirm_action: 'Zmień kod',

  // BOT
  bot_greeting: (name) => (name ? `Cześć, ${name}! 👋` : 'Cześć! 👋'),
  bot_onboarding:
    'To jest VeylMe — anonimowe pytania.\n\n' +
    'Otwórz Mini App, opublikuj kartę «Zapytaj mnie anonimowo» w swojej Story — ' +
    'i otrzymuj anonimowe pytania właśnie tutaj.\n\n' +
    '⚠️ 18+. Bądź szanujący: nękanie, groźby i zakazane treści ' +
    'są niedozwolone. Anonimowość ≠ bezkarność — naruszenia trafiają do moderacji.',
  bot_open_btn: 'Otwórz VeylMe',
  notify_answer_btn: 'Odpowiedz',
  bot_invite_text:
    'Ktoś udostępnił link do VeylMe.\n\n' +
    'Otwórz Mini App, aby zadać anonimowe pytanie:',
  bot_invite_btn: 'Zapytaj anonimowo',

  // WORK-027 i18n sweep
  tagline: 'Zapytaj mnie anonimowo',
  share_ask_action: 'Zapytaj',
  share_answered_text: 'Odpowiedziałem/am na anonimowe pytanie 👀',
  err_not_in_telegram: 'Mini App nie działa w Telegramie. Uruchom ponownie aplikację.',
  badge_viral_starter: 'Wirusowy start',
  badge_storyteller: 'Gawędziarz',
  badge_loop_master: 'Mistrz pętli',
  theme_confession: 'Wyznania',
  theme_guesswho: 'Zgadnij kto',
  rw_format_named: (name) => `format «${name}»`,
  card_label_question: 'Pytanie',
  card_label_answer: 'Odpowiedź',
  card_invite_subtitle: 'anonimowo, bez rejestracji',
  card_code_hint: 'WPISZ KOD W APLIKACJI',
  share_msg_title: (brand) => `${brand} · Anonimowe pytania`,
  notify_new_question: '🔔 Ktoś zadał ci anonimowe pytanie',
  notify_unanswered_reminder: (n) =>
    plural('pl', n, {
      one: '🔔 Masz {n} nieodpowiedziane pytanie',
      few: '🔔 Masz {n} nieodpowiedziane pytania',
      many: '🔔 Masz {n} nieodpowiedzianych pytań',
      other: '🔔 Masz {n} nieodpowiedzianych pytań',
    }),
  notify_ban_permanent: 'na stałe',
  notify_ban_until: (date) => `do ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Jesteś zablokowany w VeylMe ${untilPhrase}. Zbyt wielu odbiorców zgłosiło Twoje wiadomości.\nJeśli uważasz, że to pomyłka, możesz złożyć odwołanie w aplikacji.`,
  notify_warning_msg:
    '⚠️ Kilku odbiorców zgłosiło Twoje wiadomości. Jeszcze trochę i zostaniesz zablokowany w VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Moje pytania',
  my_questions_empty_title: 'Nie zadałeś jeszcze żadnego pytania',
  my_questions_empty_desc: 'Zadaj pytanie w czyjejś skrzynce — odpowiedź pojawi się tutaj.',
  my_questions_loading: 'Sprawdzanie odpowiedzi…',
  my_questions_waiting: 'Czeka na odpowiedź',
  my_questions_answer_label: 'Odpowiedź',
  settings_my_questions: 'Moje pytania',
  ask_sent_find_reply_hint: 'Odpowiedź znajdziesz później w «Moje pytania».',
  inbox_story_nonpremium_hint: 'Link do Story nie jest klikalny bez Telegram Premium, dlatego pokazujemy kod — udostępnienie na czacie jest pewniejsze.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Przepustka Telegrama wygasła',
  session_expired_desc: 'Telegram wydaje aplikacji przepustkę tylko raz, przy uruchomieniu, a ta już wygasła. Otwórz aplikację ponownie — zaczęty tekst zapisaliśmy.',
  session_expired_desc_no_storage: 'Twój dostęp do Telegrama wygasł i trzeba ponownie otworzyć aplikację. Nie udało się zapisać wpisanego tekstu — skopiuj go, zanim wyjdziesz.',
  session_expired_reopen: 'Otwórz ponownie',
  session_expired_stuck_title: 'Telegram wydał tę samą starą przepustkę',
  session_expired_stuck_desc: 'Zamknij aplikację całkowicie z menu bota i otwórz ją znowu — wtedy Telegram wyda nową przepustkę.',
  session_auth_failed_title: 'Nie udało się potwierdzić logowania',
  session_auth_failed_desc: 'Telegram nie potwierdził logowania do aplikacji. Zamknij aplikację i otwórz ją ponownie z czatu z botem.',
  session_expired_manual_close: 'Aplikacja nie może się tu zamknąć sama — zamknij ją samodzielnie i otwórz ponownie z czatu z botem.',
  session_expiring_soon: 'Przepustka Telegrama wkrótce wygaśnie. Otwórz aplikację ponownie, żeby nic nie przepadło.',
  my_questions_check_failed: 'Nie udało się sprawdzić odpowiedzi. Spróbuj później.',
  settings_notifications_load_error: 'Nie udało się wczytać ustawienia.',
};
